
import React, {useState, useEffect} from "react";
import "./Academy.css";
import Videos from "../Videos";
import { useSelector } from "react-redux";

function Academy() {
  const selectedLanguage = useSelector((state) => state.language.language);

  const englishData = {
    english: "Turn your dream of obtaining a driving license into a reality. Featuring all the essential theoretical and practical aspects of driving training, this video lesson series guides you to become a skilled driver while making it easier than ever to pass your exam. We are always committed to providing you with a high-quality and reliable service.",
    sinhala:
      "රියදුරු බලපත්‍රය සිහිනයක් නොව සැබෑවක් කරගන්න. රියදුරු පුහුණුවට අදාළ සියලුම සිද්ධාන්ත සහ ප්‍රායෝගික කරුණු ඇතුළත් මෙම වීඩියෝ පාඩම් මාලාව, ඔබව දක්ෂ රියදුරෙකු කිරීමට මෙන්ම විභාගය ඉතා පහසුවෙන් ජය ගැනීමටත් මඟ පෙන්වයි. ගුණාත්මක සහ විශ්වසනීය සේවාවක් සමඟින් අපි සැමවිටම ඔබ අසලින්ම සිටින්නෙමු.",
    tamil:
      "உங்கள் ஓட்டுநர் உரிமக் கனவை நனவாக்குங்கள். ஓட்டுநர் பயிற்சிக்கான அனைத்து கோட்பாடு மற்றும் செய்முறை விளக்கங்களை உள்ளடக்கிய இந்த வீடியோ பாடத் தொடர், உங்களை ஒரு சிறந்த ஓட்டுநராக மாற்றுவதுடன், தேர்வில் மிக எளிதாக வெற்றி பெறவும் வழிகாட்டுகிறது. தரமான மற்றும் நம்பகமான சேவையுடன் நாங்கள் எப்போதும் உங்களுடன் இருப்போம்.",
  };


  const [language, setLanguage] = useState(englishData.sinhala);

  
  
      useEffect(() => {
      switch (selectedLanguage.value) {
        case "english":
          setLanguage(englishData.english);
          break;
        case "tamil":
          setLanguage(englishData.tamil);
          break;
        default:
          setLanguage(englishData.sinhala);
          break;
      }
    }, [selectedLanguage]);



    return (
      <div className="container navbar-offset">
        <div className="mb-2">
          <h2 className="fs-1">
            Our <span className="text-warning fw-bold">Lessons</span>
          </h2>
          <h6 className="text-muted lh-base text-alignment">{language}</h6>
        </div>
        <Videos />
      </div>
    );
}

export default Academy;
